import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  adminTable,
  adminTableHeaderCell,
  adminTableDataCell,
} from '../common/AdminTableStyles';

const Container = styled.div`
  #bigbox & {
    clear: both;
    padding: 1em;
  }
`;

const Table = styled.table`
  ${adminTable};
  font-size: 14px;

  thead th {
    ${adminTableHeaderCell};
    background-color: #fff;
    position: relative;

    .sort-icons {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      font-size: 10px;

      span {
        cursor: pointer;
        line-height: 10px;
        color: #9CA3AF;
        display: block;
      }

      .active {
        color: #A855F7;
      }
    }
  }

  tbody td {
    ${adminTableDataCell};
  }

  a {
    color: ${({ colors }) => colors.buttonBackground};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
const AnnouncementItem = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  li a {
    color: inherit;
    text-decoration: none;
    font-size: 0.95em;
    &:hover { text-decoration: underline; }
  }
  strong { display: block; font-size: 1em; margin-bottom: 0.2em; }
  small { font-size: 0.85em; color: #666; }
`;

export default function SubscriptionAnnouncements({ colors }) {
  const announcements = useSelector(s => s.auth.announcements || []);

  // format e.g. "Feb 1"
  const fmtDate = iso => {
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <Container id="bigbox">
      <Table colors={colors}>
        <thead>
          <tr>
            <th>Announcement</th>
            <th></th><th></th>
          </tr>
        </thead>
        <tbody>
          {announcements.map(a => {
            const summary = typeof a.summary === 'string' ? a.summary : '';
            const preview =
              summary.length > 200 ? summary.slice(0, 200) + '…' : summary;
            return (
            <tr key={a.id}>
              <td>
                <AnnouncementItem>
                  <li>
                  <Link
 to={`/admincentral/announcements/view/${a.id}`}
  state={{ announcement: a }}
>
                      <strong>{a.title}</strong>
                      <small>{fmtDate(a.date)}</small>
                      <br />
                      {/* truncate summary to ~200 chars */}
                      {preview}
                    </Link>
                  </li>
                </AnnouncementItem>
              </td>
              {/* spacer cells */}
              <td colSpan="2">&nbsp;</td>
            </tr>
          )})}
          {announcements.length === 0 && (
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', padding: '1em' }}>
                No announcements found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <div style={{ clear: 'both' }} />
    </Container>
  );
}
